<template>
    <contained-page-layout>
        <document-title value="Orders"></document-title>
        <view-all-orders></view-all-orders>
    </contained-page-layout>
</template>


<script>
import ViewAllOrders from '../../components/orders/ViewAllOrders';

export default {
    name : "TheOrdersView",

    components : {
        ViewAllOrders,
    },

}

</script>

<style scoped lang="scss">
</style>
